import React, { ComponentProps, FC, ReactNode } from 'react';

import FaqSection from '@rover/components/src/FaqSection';
import HTMLBox from '@rover/kibble/patterns/HTMLBox';

export type LandingFaqItem = {
  question: string;
  answer: string;
  faqId?: number;
};

export type LandingFaqListProps = Omit<ComponentProps<typeof FaqSection>, 'faqItems'> & {
  faqs: LandingFaqItem[];
  children?: ReactNode;
};

const LandingFaqList: FC<LandingFaqListProps> = ({ faqs, children, ...sectionProps }) => {
  if (faqs.length === 0) return null;

  return (
    <FaqSection
      {...sectionProps}
      faqItems={faqs.map(({ question, answer, faqId }) => ({
        faqId,
        itemHeading: question,
        itemBody: <HTMLBox text={answer} />,
      }))}
    >
      {children}
    </FaqSection>
  );
};

export default LandingFaqList;
